import { Alert } from '@shared/ui/alert/alert';
import React from 'react'
import { NavLink } from 'react-router-dom';
import s from './personal-alert.module.scss'
import { useAddTeacherReviewModal } from '@features/student/add-teacher-review/model/useAddTeacherReviewModal';
import { getFullName } from '@utils/lib/getFullname';

export const PersonalAlert = ({type, teacher}) => {
	const { open: openReviewModal } = useAddTeacherReviewModal()

	return (
		<>
			{{feedback_request:<Alert
				index={teacher?.teacher_slug}
				title={"Как прошел урок?"}
				subtitle={
					<>

						Оставьте отзыв о преподавателе <NavLink className={s.payLink} to={`/teacher/${teacher?.teacher_slug}`}>{getFullName(teacher)}</NavLink><br/>
						<NavLink className={s.payLink} onClick={() => openReviewModal({teacher_id: teacher?.teacher_slug})}>Оставить отзыв</NavLink>
					</>
				}
			/>}[type]}
		</>
	)
}
